import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertHelp32Icon extends BaseIcon {
  getChildren = () => [
    <path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z" fill="#3b8fd6"/>,
    <circle fill="#fff" cx="16" cy="8.5" r="1.5"/>,
    <path fill="#fff" d="M18 25h-2c-.6 0-1-.4-1-1V14h-2c-.6 0-1-.4-1-1s.4-1 1-1h3c.6 0 1 .4 1 1v10h1c.6 0 1 .4 1 1s-.4 1-1 1z"/>
          ]
  getViewBox = () => '0 0 32 32'
}
